import { type Guard } from '@capsicum/common';
import { useCallback } from 'react';

import { useDeeplinkRedirectGuard } from '../hooks/useDeeplinkRedirectGuard';

/**
 * Guard for ensuring that user is routed to previously stored deeplink.
 */
export const DeeplinkRedirectGuard: Guard = () => {
	const { deepLinkRedirect, navigateToDeepLink } = useDeeplinkRedirectGuard();

	const onDenied = useCallback(() => {
		navigateToDeepLink();
	}, [navigateToDeepLink]);

	const status = deepLinkRedirect ? 'denied' : 'allowed';

	return {
		onDenied,
		status
	};
};
